module.exports = __webpack_public_path__ + "img/as.7c963cb2.svg";